import React, { useEffect, useState } from 'react';
import { publicConfig } from '../../../services';
import { PopupContainer } from '../../popups';
import { ButtonColor, ButtonContainer } from '../../button';
import * as S from './technicalIssuePopup.styled';

export const TechnicalIssuePopup = () => {
  const [isPopupOpened, setIsPopupOpened] = useState<boolean>(false);

  useEffect(() => {
    if (publicConfig.TECHNICAL_ISSUES_POPUP_ENABLED === 'true') {
      setTimeout(() => {
        setIsPopupOpened(true);
      }, 1500);
    }
  }, []);

  return (
    <PopupContainer
      styleSettings={{
        paddingSticky: {
          top: '20px',
          right: '20px',
          bottom: '20px',
          left: '20px',
        },
        paddingContent: {
          top: '48px',
          right: '24px',
          bottom: '48px',
          left: '24px',
        },
      }}
      isOpened={isPopupOpened}
      closeOutside
      fullHeightMobile={false}
    >
      <S.TechnicalIssue>
        <S.TechnicalIssueImage>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            fill="none"
          >
            <circle cx="24" cy="24" r="24" fill="#000" />
            <path
              fill="#fff"
              fillRule="evenodd"
              d="M24 12.5a1 1 0 0 1 1 1v15a1 1 0 1 1-2 0v-15a1 1 0 0 1 1-1Z"
              clipRule="evenodd"
            />
            <path
              fill="#fff"
              d="M25.5 33.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
            />
          </svg>
        </S.TechnicalIssueImage>
        <S.TechnicalIssueTitle>
          На платформе Skillbox технические неполадки
        </S.TechnicalIssueTitle>
        <S.TechnicalIssueSubtitle>
          Возможны ошибки при открытии курсов и переходе к обучению. Рекомендуем
          повторить попытку позже.
        </S.TechnicalIssueSubtitle>
        <ButtonContainer
          onClick={() => {
            setIsPopupOpened(false);
          }}
          fullWidth
          title={'Понятно'}
          color={ButtonColor.purple}
        />
      </S.TechnicalIssue>
    </PopupContainer>
  );
};
